import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions';

import { Grid, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import classes from './DetallesComprobanteVenta.css';
import { storageMonedaSigno } from '../../../../assets/shared/sessionData';
import { formatNumberWithMonedaSigno } from '../../../../assets/shared/formatNumber';
import TableDetallesComprobante from '../TablaDetallesComprobante/TablaDetallesComprobante';
import AccordionObservacionesComprobante from '../AccordionObservacionesComprobante/AccordionObservacionesComprobante';
import moment from 'moment';
import Spinner from '../../../UI/Spinner/Spinner';
import TableDetallesRecibo from './TablaDetallesRecibo';
import LabelGridTitleDescription from '../../../UI/LabelGridTitleDescription/LabelGridTitleDescription';

const DetallesComprobanteVenta = (props) => {
  const { onLoadDetallesComprobante, onChangeModalBody, comprobante } = props;
  const { idComproba, idSucursal, idSistema, proveedor, referencia, numeroExterno, cobranza } = comprobante;
  const [loading, setLoading] = useState(false);
  const [comprobanteLocal, setComprobanteLocal] = useState({
    fecha: '',
    referencia: '',
    numeroExterno: '',
    idSucursal: '',
    idSistema: '',
    cliente: '',
    idComproba: '',
    detalleComprobante: [],
    subtotal: 0,
    bonificacion1: 0,
    porcBonif1: 0.0,
    bonificacion2: 0,
    porcBonif2: 0.0,
    subtotalBonificado: 0,
    impuestos: 0,
    importe: 0,
    direccion: '',
    localidad: '',
    provincia: '',
    cotizacion: 0
  });

  const buildInfoTotal = (data) => {
    const titlePorcBonif1 = data.porcentajeBonificacion1 ? `B. 1 (${data.porcentajeBonificacion1})` : 'B. 1 (0.00)';
    const titlePorcBonif2 = data.porcentajeBonificacion2 ? `B. 2 (${data.porcentajeBonificacion2})` : 'B. 2 (0.00)';

    return (
      <div className={classes.contenedorTotales}>
        <Grid container>
          <Grid container item xs={11} justify="flex-start" spacing={4}>
            <TitleMontoTotales title="Subtotal" monto={comprobanteLocal.subtotal} simbolo={comprobanteLocal.simboloMoneda}/>
            <TitleMontoTotales title={titlePorcBonif1} monto={comprobanteLocal.bonificacion1} simbolo={comprobanteLocal.simboloMoneda}/>
            <TitleMontoTotales title={titlePorcBonif2} monto={comprobanteLocal.bonificacion2} simbolo={comprobanteLocal.simboloMoneda}/>
            <TitleMontoTotales title="Subtotal" monto={comprobanteLocal.subtotalBonificado} simbolo={comprobanteLocal.simboloMoneda}/>
            <TitleMontoTotales title="Impuestos" monto={comprobanteLocal.impuestos} simbolo={comprobanteLocal.simboloMoneda}/>
          </Grid>
          <Grid container item xs={1} justify="flex-end">
            <TitleMontoTotales title="Total" monto={comprobanteLocal.importe} simbolo={comprobanteLocal.simboloMoneda}/>
          </Grid>
        </Grid>
      </div>
    );
  };

  const TitleMontoTotales = ({ title, monto, xs, simbolo } = props) => {
    return (
      <Grid item xs={xs} className={classes.titleDescriptionContainer}>
        <Grid item className={classes.titleTotales}>
          {title}
        </Grid>
        <Grid item className={classes.montoTotales}>
          {formatNumberWithMonedaSigno(monto, simbolo)}
        </Grid>
      </Grid>
    );
  };

  const InfoComprobanteContainer = (props) => {
    return (
      <Grid className={classes.infoComprobanteContainer} container spacing={1}>
        {props.children}
      </Grid>
    );
  };

  const InfoComprobanteRow = (props) => {
    return (
      <Grid className={classes.infoComprobanteRow} container item xs={12} spacing={5}>
        {props.children}
      </Grid>
    );
  };

  const InfoTitleDescription = ({ xs, title, description, descriptionSmall, style } = props) => {
    return (
      <Grid style={style} item xs={xs} className={classes.titleDescriptionContainer}>
        <Grid item className={classes.title}>
          {title}
        </Grid>
        <Grid item className={classes.description}>
          {description}
        </Grid>
        <Grid item className={classes.descriptionSmall}>
          {descriptionSmall}
        </Grid>
      </Grid>
    );
  };

  const buildInfoComprobante = (data) => {
    return (
      <InfoComprobanteContainer>
        <InfoComprobanteRow>
          <InfoTitleDescription title={proveedor ? 'Proveedor' : 'Cliente'} description={proveedor ? proveedor : data.cliente.trim()} xs={3} />
          <InfoTitleDescription title="Comprobante" description={data.comprobante} xs={2} />
          <InfoTitleDescription title="Número" description={numeroExterno} xs={3} />
          <InfoTitleDescription title="Fecha" description={moment(data.fecha).format('DD/MM/YY')} xs={1} />
          <InfoTitleDescription title="Cond. de pago" description={data.condicionPago} xs={3} />
        </InfoComprobanteRow>
        <InfoComprobanteRow>
          <InfoTitleDescription title="Dirección" descriptionSmall={data.direccion.trim()} xs={3} />
          <InfoTitleDescription title="Localidad" descriptionSmall={data.localidad.trim()} xs={2} />
          <InfoTitleDescription title="Provincia" descriptionSmall={data.provincia.trim()} xs={3} />
          <InfoTitleDescription title="Referencia" description={referencia} xs={1} />
          <InfoTitleDescription title="Estado comprobante" descriptionSmall={data.estado} xs={3} />
        </InfoComprobanteRow>
      </InfoComprobanteContainer>
    );
  };

  const buildModalHeader = () => {
    return (
      <div className={classes.TitleCard}>
        <p style={{ fontWeight: 'bold', marginBottom: '1px' }}>DETALLE DE COMPROBANTE</p>
        <div>
          <IconButton aria-label="close" onClick={() => props.onCloseShowModal()}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
    );
  };

  const buildModalFooter = (data) => {

    let monto = 0; 
    if(comprobante.debe)
      monto = formatNumberWithMonedaSigno(0, storageMonedaSigno()) === comprobante.debe ? comprobante.haber : comprobante.debe
    else
      monto = formatNumberWithMonedaSigno(comprobante.monto, storageMonedaSigno())
    return (
      <InfoComprobanteContainer>
        <InfoComprobanteRow>
          <InfoTitleDescription
            title="Confección"
            descriptionSmall={moment(data.fechaConfeccion).format('DD/MM/YY')}
            xs={1}
          />
          <LabelGridTitleDescription title="Cotización" descriptionSmall={`${formatNumberWithMonedaSigno(1, comprobanteLocal.simboloMoneda)} = ${formatNumberWithMonedaSigno(comprobanteLocal.cotizacion, '$')}`} xs={1.25} />
          <LabelGridTitleDescription title={`Total ${storageMonedaSigno()}`} descriptionSmall={`${monto}`}/>
          {/* <LabelGridTitleDescription title="Usuario" descriptionSmall={'USUARIO TEST'} xs={3} /> */}
        </InfoComprobanteRow>
      </InfoComprobanteContainer>
    );
  };

  const bodyComprobante = (data) => {
    return (
      <Fragment>
        {buildModalHeader()}
        {buildInfoComprobante(data)}
        <div style={{ marginBottom: '10px' }} />

        {data.observaciones && data.observaciones.length !== 0 && (
          <AccordionObservacionesComprobante observaciones={data.observaciones} />
        )}
        <TableDetallesComprobante articulos={data.detalleComprobante} simbolo={data.simboloMoneda}/>
        <div style={{ marginBottom: '10px' }} />
        {buildInfoTotal(data)}

        <hr />
        {buildModalFooter(data)}
      </Fragment>
    )
  }

  //#region Detalle Recibos
  const buildInfoRecibo = (data) => {
    return (
      <InfoComprobanteContainer>
        <InfoComprobanteRow>
          <InfoTitleDescription title='Cliente' description={proveedor ? proveedor : data.cliente.trim()} xs={3} />
          <InfoTitleDescription title="Comprobante" description={data.comprobante} xs={2} />
          <InfoTitleDescription title="Número" description={numeroExterno} xs={3} />
          <InfoTitleDescription title="Fecha" description={moment(data.fecha).format('DD/MM/YY')} xs={1} />
        </InfoComprobanteRow>
        <InfoComprobanteRow>
          <InfoTitleDescription title="Dirección" descriptionSmall={data.direccion.trim()} xs={3} />
          <InfoTitleDescription title="Localidad" descriptionSmall={data.localidad.trim()} xs={2} />
          <InfoTitleDescription title="Provincia" descriptionSmall={data.provincia.trim()} xs={3} />
          <InfoTitleDescription title="Referencia" description={referencia} xs={1} />
          <InfoTitleDescription title="Estado comprobante" descriptionSmall={data.estado} xs={3} />
        </InfoComprobanteRow>
      </InfoComprobanteContainer>
    );
  };

  const bodyRecibo = (data) => {
    return (
      <Fragment>
        {buildModalHeader()}
        {buildInfoRecibo(data)}
        <div style={{ marginBottom: '10px' }} />

        {data.observaciones && data.observaciones.length !== 0 && (
          <AccordionObservacionesComprobante observaciones={data.observaciones} />
        )}
        <TableDetallesRecibo articulos={data.detalleComprobante} simbolo={data.simboloMoneda} />
        <div style={{ marginBottom: '10px' }} />
        {buildInfoTotal(data)}

        <hr />
        {buildModalFooter(data)}
      </Fragment>
    )
  }

  //#endregion

  const ModalBody = (data) => {
    return data 
    ? cobranza ? bodyRecibo(data) : bodyComprobante(data)
    : (
      <div style={{ textAlign: 'center' }}>
        No se pudo cargar el comprobante solicitado. Por favor, intente más tarde.
      </div>
    );
  };

  const onLoadComprobanteSuccess = (detallesComprobante) => {
    setComprobanteLocal(detallesComprobante);
    setLoading(false);
  }

  const onLoadComprobanteError = (error) => {
    onChangeModalBody(<div style={{ textAlign: 'center' }}>Error al cargar los detalles del comprobante</div>);
    setLoading(false);
  }
  
  useEffect(() => {
    setLoading(true);
    onLoadDetallesComprobante(idSucursal, idSistema, idComproba, referencia, cobranza, onLoadComprobanteSuccess, onLoadComprobanteError);
  }, []);

  return loading ? 
    (
      <div className={classes.Spinner}>
        <Spinner />
      </div>
    ): (
      ModalBody(comprobanteLocal)
    )
}

const mapStateToProps = (state) => ({
  showModal: state.modals.globalModal.show,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onCloseShowModal: () => dispatch(actions.showGlobalModal(false, '', undefined, undefined, true, true , 'lg')),
    onChangeModalBody: (newBody) => dispatch(actions.changeGlobalModalBody(newBody)),
    onLoadDetallesComprobante: (idSucursal, idSistema, idComproba, nroReferencia, cobranza, success, errorFail) =>
      dispatch(actions.loadDetalleComprobante(idSucursal, idSistema, idComproba, nroReferencia, success, errorFail, cobranza))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DetallesComprobanteVenta);